import React, {useState, useEffect} from 'react';
import {defaultErrorHandler} from '../../../context/context';
import customFormsClientDataClient from '../../../infrastructure/acerill/custom-forms-client-data-client';
import CenteredSpinner from '../../../libs/react-components-admin/spinners/centered-spinner';

class BooleanConditionValueSelector extends React.Component {

  constructor(props) {
    super(props);
    const model = props.model || {};
    if (model.value == null) {
      model.type = 'value';
      model.value = true;
      props.onChange(model);
    }
    this.state = {
      model: model,
    };
  }

  updateModel(fieldName, value) {
    this.setState(
      prevState => {
        const model = {...prevState.model};
        model[fieldName] = value;
        return {model: model};
      },
      () => this.props.onChange(this.state.model)
    );
  }

  render() {
    return <select className="form-select"
                   value={this.state.model.value.toString()}
                   onChange={e => {
                     const value = e.target.value;
                     this.updateModel('value', (typeof value === 'boolean') ? value : value === 'true');
                   }}>
      <option value="true">true</option>
      <option value="false">false</option>
    </select>;
  }

}
export {BooleanConditionValueSelector};

class RadioConditionValueSelector extends React.Component {

  constructor(props) {
    super(props);
    const model = props.model || {};
    if (model.value == null || !props.radioGroupFields.map(f => f.radioValue).includes(model.value)) {
      model.type = 'value';
      model.value = props.radioGroupFields[0].radioValue;
      props.onChange(model);
    }
    this.state = {
      model: model,
    };
  }

  updateModel(fieldName, value) {
    this.setState(
      prevState => {
        const model = {...prevState.model};
        model[fieldName] = value;
        return {model: model};
      },
      () => this.props.onChange(this.state.model)
    );
  }

  render() {
    return <select className="form-select"
                   value={this.state.model.value || ''}
                   onChange={e => this.updateModel('value', e.target.value)}>
      {this.props.radioGroupFields.map(field =>
        <option key={field.id} value={field.radioValue}>{field.radioValue}</option>
      )}
    </select>;
  }

}
export {RadioConditionValueSelector};

const DropdownConditionValueSelector = ({fieldConfig, value, onChange}) => {

  const [model, setModel] = useState({...(value || {}), type: 'value'});
  const [values, setValues] = useState();

  useEffect(() => onChange(model), [model]);
  useEffect(() => {
    if (!values || values.length === 0) {
      return;
    }
    if (model.value == null || !values.includes(model.value)) {
      setModel(m => ({...m, value: values[0]}));
    }
  }, [values]);

  useEffect(() => {
    getValues()
      .then(values => setValues(values))
      .catch(defaultErrorHandler);
  }, []);

  const getValues = () => {
    switch(fieldConfig.dataSource) {
    case 'COUNTRIES':
      return customFormsClientDataClient.getCountries()
        .then(countries => Object.values(countries).sort());
    case 'US_STATES':
      return customFormsClientDataClient.getUsStates()
        .then(states => Object.values(states).sort());
    default:
      return Promise.resolve(fieldConfig.possibleValues || []);
    }
  };

  if (!values) {
    return <CenteredSpinner/>;
  }
  return <select className="form-select"
                 value={model.value || ''}
                 onChange={e => setModel({...model, value: e.target.value})}>
    {values.map((value, i) => <option key={i} value={value}>{value}</option>)}
  </select>;
};
export {DropdownConditionValueSelector};
